import React, { useState, useEffect, useMemo } from 'react';
import { required as checkedRequired, maxLength as checkedMaxLength } from '@parchment/validation-utils';
import styled from 'styled-components';
import { VALIDATION_STATES } from '../../utils/constants';
import runValidator from './runValidator';
const StyledMessageList = /*#__PURE__*/styled.ul.withConfig({
  displayName: "FieldValidation__StyledMessageList",
  componentId: "sc-17q9jxp-0"
})(["padding-left:15px;text-align:left;"]);
const noop = () => undefined;
function buildErrorMessage(validationResults) {
  const message = validationResults.filter(result => !result.valid).map(result => {
    return /*#__PURE__*/React.createElement("li", {
      key: `${result.message}`
    }, result.message);
  });
  return /*#__PURE__*/React.createElement(StyledMessageList, null, message);
}
export function FieldValidation(_ref) {
  let {
    children,
    required = false,
    maxCharacterLimit,
    onValidate = noop,
    ...props
  } = _ref;
  const [valid, setValid] = useState(VALIDATION_STATES.neutral);
  const [validationResults, setValidationResults] = useState([]);
  const errorMessage = useMemo(() => buildErrorMessage(validationResults), [JSON.stringify(validationResults)]);
  useEffect(() => {
    const tempValid = validationResults.length ? VALIDATION_STATES.error : VALIDATION_STATES.success;
    setValid(tempValid);
    onValidate(tempValid, errorMessage);
  }, [errorMessage]);
  const doValidation = async value => {
    const tempValidationResults = [];
    if (required) {
      const req = {
        message: 'Field is Required',
        callback: inputValue => checkedRequired(`${inputValue || ''}`),
        ...(typeof required === 'object' ? required : {})
      };
      tempValidationResults.push(await runValidator(req, value));
    }
    if (maxCharacterLimit) {
      const callback = typeof maxCharacterLimit === 'number' ? inputValue => checkedMaxLength(maxCharacterLimit, `${inputValue || undefined}`) : () => true;
      const maxLengthValidator = {
        message: 'You have exceeded the MAX number of characters',
        callback,
        ...(typeof maxCharacterLimit === 'object' ? maxCharacterLimit : {})
      };
      tempValidationResults.push(await runValidator(maxLengthValidator, value));
    }
    if (props.validators && (value || required)) {
      tempValidationResults.push(...(await Promise.all(props.validators.map(validator => runValidator(validator, value)))));
    }
    setValidationResults(tempValidationResults.filter(result => !result.valid));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, children(valid, doValidation, {
    errorMessage,
    required,
    maxCharacterLimit,
    onValidate,
    ...props
  }));
}
export default FieldValidation;